import type { IBuildGemXQlQueryParams } from '~/core/gemxql';

import { buildGemXQlQuery } from '~/core/gemxql';

export type IBuildReportQueryParams = IBuildGemXQlQueryParams;

export const buildReportQuery = (params: IBuildReportQueryParams) => {
  return buildGemXQlQuery({ ...params });
};
